import { setStoredProjectFile } from "../../utils/storage";
import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import { Store } from "../../Store";
import React, { useContext } from "react";
import { ToastContainer, toast } from 'react-toastify';
import { AddUpdateDelete_CHARACTER_FOR_PROJECT } from "../../ApiEndpoints";
import axios from "axios";
import { characterWriteErrorMessage } from "../../Components/VoiceCreation/renameCharacter.js";

const AttributionScreen = () => {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { projectFile } = state;

  const updateProject = async () => {
    // Save project details to context and localStorage first
    ctxDispatch({ type: "PROJECT_FILE", payload: projectFile });
    setStoredProjectFile(projectFile)

    try {
      await axios.post(AddUpdateDelete_CHARACTER_FOR_PROJECT, {
        projectId: projectFile.id,
        characters: projectFile.characters,
      });
      toast.success("Character attribution saved");
    } catch (error) {
      toast.error(characterWriteErrorMessage(error, "Could not save character attribution"));
    }
  } 

  const updateCharacter = (index, value) => {
    projectFile.characters[index].actorName = value;
    updateProject();
  }
  
  return (
    <Grid
      item
      container
      justifyContent="center"
      marginTop={2}
    >
      <ToastContainer position="top-center" />
      <Grid item container xs={11.5} direction="column">
        <Grid item container direction="row">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Character Name</TableCell>
                <TableCell>Actor Name</TableCell>
                <TableCell>Localization Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {projectFile.characters && projectFile.characters.map((character, index) => (
                <TableRow key={index}>
                  <TableCell>{character.displayName}</TableCell>
                  <TableCell>
                    <TextField
                      defaultValue={character.actorName}
                      onBlur={(e) => {
                        updateCharacter(index, e.target.value);
                       }} >
                    </TextField>
                  </TableCell>
                  <TableCell>Timbre Clone</TableCell>
                </TableRow>
              ))}              
            </TableBody>
          </Table>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AttributionScreen;
